import { useTranslation } from "react-i18next";
import Text from "../content/Text";
import { Link } from "react-router-dom";

const DeleteAccountLinkButton = () => {
  const { t } = useTranslation();

  return (
    <Link to="/user-delete">
      <Text
        variant="small"
        className="flex justify-center text-[#757575] underline cursor-pointer"
      >
        {t("userDelete.deleteAccount")}
      </Text>
    </Link>
  );
};

export default DeleteAccountLinkButton;
